import * as tslib_1 from "tslib";
import axios from "axios";
export var store = {
    devices: [],
    deviceTemp: [],
    sessionToken: null,
    documentsRead: [],
    loggedIn: false,
    products: {},
};
export function loadStore() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var documentsRead, devices_1, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    documentsRead = JSON.parse(localStorage.getItem("documentsRead"));
                    if (Array.isArray(documentsRead))
                        store.documentsRead = documentsRead;
                    store.sessionToken = localStorage.getItem("sessionToken");
                    store.loggedIn = !!store.sessionToken;
                    devices_1 = [];
                    if (!store.loggedIn) return [3 /*break*/, 2];
                    return [4 /*yield*/, axios.get("devices/userDevices", { params: { token: store.sessionToken } })];
                case 1:
                    devices_1 = (_a.sent()).data;
                    store.deviceTemp = store.deviceTemp.filter(function (dt) { return devices_1.map(function (d) { return d.serial; }).indexOf(dt.serial) == -1; });
                    _a.label = 2;
                case 2:
                    store.devices = tslib_1.__spread(devices_1, store.deviceTemp);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function hasFullAccessToDevice(serialNumber) {
    return store.devices.find(function (d) { return d.serial == serialNumber; }) != null;
}
export function persistStore() {
    // localStorage.setItem("devices", JSON.stringify(store.devices));
    localStorage.setItem("documentsRead", JSON.stringify(store.documentsRead));
}
